import { useMemo } from 'react'
import { SlugifiedAttributesFilterValue } from 'services/providers/bapi/entities/filters/normalize'
import { DropdownOptionType } from 'uiComponents/molecules/Dropdown/types'

export const useDropdownOptions = ({
  options,
  selectedValues,
  toggleSelection,
}: {
  options: SlugifiedAttributesFilterValue[]
  selectedValues: string[]
  toggleSelection: (id: string) => void
}) => {
  const modifiedOptions: DropdownOptionType[] = options.map(option => {
    return {
      id: option.id,
      label: option.name,
      value: option.name,
      disabled: false,
    }
  })

  const dropdownOptions = [{ options: modifiedOptions }]

  const selection = useMemo(() => {
    return modifiedOptions.filter(option =>
      selectedValues.includes(option.id as string),
    )
  }, [modifiedOptions, selectedValues])

  const onVariantSelected = (option: DropdownOptionType) => {
    const selectedOption = modifiedOptions.find(
      modifiedOption => modifiedOption.id === option.id,
    )

    if (selectedOption) {
      toggleSelection(selectedOption.id as string)
    }
  }

  return { dropdownOptions, selection, onVariantSelected }
}
